export const baserUrl = process.env.NODE_ENV === 'development' ? 'https://firepoint.guanyingis.com/firepointApi' : '/firepointApi/'
export const wsUrl = 'wss://firepoint.guanyingis.com/firepointWss/webSocket/warningMsg'
